/**
 * Antonin's template review of 3 Nov, behind the `templateReview` switch (`?x=template-review`). It only sets or removes
 * `data-template-review="on"` on the root element. The CSS parts of the review (the reason headline, the step bar's section tints)
 * are scoped to that attribute, so with the switch off nothing changes.
 */
export function applyTemplateReviewLook(on: boolean, root: HTMLElement = document.documentElement): void {
  if (on) root.dataset.templateReview = 'on';
  else delete root.dataset.templateReview;
}
